module.exports = __webpack_public_path__ + "static/fire-giants-attack-23952691fd0c476ab62a3fef82117f94.png";